// extracted by mini-css-extract-plugin
export default {"container":"loading_container__nJKQE","animation":"loading_animation__ARbj4","spinner":"loading_spinner__jEMG-","text":"loading_text__cplMe"};